// keywords.js

import { baseURL } from 'utils/api'
import Dictionary from '../dictionary'
import axios from 'axios'

const { keywords } = Dictionary

const keywordsServies = {
  view: async (paramsObj) => {
    return axios.get(baseURL + keywords.list(),{params: paramsObj})
  },
  add: async (data) => {
    return axios.post(baseURL + keywords.create(), data)
  },
  delete: async (id) => {
    return axios.delete(baseURL + keywords.delete(id))
  },
  edit: async (id, data) => {
    return axios.put(baseURL + keywords.update(id), data)
  },
  getDetailById: async (id) => {
    return axios.get(baseURL + keywords.getById(id))
  },
}
export default keywordsServies